import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import BtmFootInplay from "../assets/images/icons/home/btmFootInplay.png";
import SupportImg from "../assets/images/icons/home/whatsapp1.png";
import BtmFootHome from "../assets/images/icons/home/btmFootHome.png";
import SearchImg from "../assets/images/icons/home/loupe.png";
import BtmFootCasino from "../assets/images/icons/home/btmFootCasino.png";
import BtmFootProfile from "../assets/images/icons/home/btmFootProfile.svg";
import { useSelector } from "react-redux";
import GamesSearchModal from "../views/components/GamesSearchModal";

export default function BottomNav() {
  const location = useLocation();
  const [activePage, setActivePage] = useState("");
  const { isAuth } = useSelector((state) => state.auth);
  const { appDetails } = useSelector((state) => state.app);

  const footerPages = [
    "home",
    "live-dealer",
    "profile",
    "exchange",
    "casino/evolution",
    "casino/ezugi",
    "public-inplay",
    "public-sports",
    "/",
    "sports",
    "betby",
  ];
  useEffect(() => {
    const matchedValue = footerPages.find((f) => {
      if (f === "public-sports") {
        return location?.pathname?.split("/")?.[1] === "public-sports";
      } else {
        return location?.pathname.includes(f);
      }
    });
    if (matchedValue) {
      setActivePage(matchedValue);
    }
  }, [location]);

  return (
    <div>
      <footer className="d-lg-none">
        <div className="footer-menu position-fixed start-0 bottom-0 z-index-2 w-100">
          <ul className="d-flex justify-content-evenly m-0 p-0 list-unstyled">
            <li className="casino">
              <a
                className={activePage === "/" ? "active" : ""}
                href={isAuth ? "/" : "/"}>
                <div className="imgBox">
                  <img src={BtmFootCasino} alt="footer nav icon" />
                </div>
                <span>Casino</span>
              </a>
            </li>
            <li className="inplay">
              <a
                className={
                  activePage === "exchange" || activePage === "public-inplay"
                    ? "active"
                    : ""
                }
                href={isAuth ? "/exchange/Inplay" : "/public-inplay"}>
                <div className="imgBox">
                  <img src={BtmFootInplay} alt="footer nav icon" />
                </div>
                <span>In play</span>
              </a>
            </li>
            {/* <li className="sports">
              <a
                className={
                  activePage === "betby" || activePage === "public-sports"
                    ? "active"
                    : ""
                }
                href={isAuth ? "/casino/evolution" : "/sign-in"}
              >
                <div className="imgBox">
                  <img src={EvolutionIcons} alt="footer nav icon" />
                </div>
                <span>Evolution</span>
              </a>
            </li> */}
            <li className="home">
              <a
                className={
                  activePage === "" || activePage === "" ? "active" : ""
                }
                href="#">
                <div className="imgBox">
                  <GamesSearchModal />
                </div>
                <span>Search</span>
                {/* <div className="imgBox">
                  <img src={SearchImg} alt="footer nav icon" />
                </div>
                 */}
              </a>
            </li>
            <li className="profile">
              <a
                href={
                  appDetails?.WHATS_APP_URL != ""
                    ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                    : "#"
                }
                target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}>
                <div className="imgBox">
                  <img src={SupportImg} alt="footer nav icon" />
                </div>
                <span>Support</span>
              </a>
            </li>
            {!isAuth && (
              <li className="profile">
                <a
                  className={activePage === "sign-in" ? "active" : ""}
                  href="/sign-in">
                  <div className="imgBox">
                    <img src={BtmFootProfile} alt="footer nav icon" />
                  </div>
                  <span>Login</span>
                </a>
              </li>
            )}
            {isAuth && (
              <>
                <li className="profile">
                  <a
                    className={activePage === "profile" ? "active" : ""}
                    href="/profile">
                    <div className="imgBox">
                      <img src={BtmFootProfile} alt="footer nav icon" />
                    </div>
                    <span>Profile</span>
                  </a>
                </li>
              </>
            )}
          </ul>
        </div>
      </footer>
    </div>
  );
}
